import {Avatar, Modal} from 'antd'
import React, {useState} from 'react'
import {Resource} from '../../api/resource'
import {EyeOutlined, DownloadOutlined} from '@ant-design/icons'
import {ObsKeyToURL} from '../../api/utils'
import {CornerMarker} from '../CornerMarker'
import {useHistory} from 'react-router'
import {DownloadFileModal} from 'components/DownloadFile'
interface Props {
  resource: Resource
}

const ResourceCard: React.FC<Props> = ({resource}) => {
  const history = useHistory()
  const [modalVisible, setModalVisible] = useState(false)
  const [finishSign, setFinishSign] = useState(true)
  const previewFile = () => {
    if (resource.type === 'image') {
      setModalVisible(true)
    } else if (resource.type === 'video' || resource.type === 'doc') {
      history.push('/preview/' + resource.resource_id, resource)
    }
  }
  const handleCancel = () => {
    setModalVisible(false)
  }
  return (
    <>
      {/* <div
        className="resource-card"
        style={{ backgroundImage: `url(${ObsKeyToURL(resource.image)})` }}
      >
        <div className="file-tag">
          <CornerMarker suffix={resource.suffix} />
        </div>
        <div className="resource-info">
          <div className="resource-name second-title bold">{resource.name}</div>
          <div className="resource-author-group">
            <div className="resource-author-avatar">
              <Avatar src={ObsKeyToURL(resource.author.image)} />
            </div>
            <div className="resource-author-name">
              {resource.author.nickname || resource.author.name || resource.author.username}
            </div>
          </div>
          <div className="resource-button-group">
            {resource.type === 'other' ? (
              <div style={{ width: 114 }}></div>
            ) : (
              <Button size="large" onClick={previewFile}>
                预览
              </Button>
            )}
            <Button size="large" type="primary" onClick={() => DownloadFile(resource)} disabled={disabled}>
              下载
            </Button>
          </div>
        </div>
      </div> */}
      <div className="resource-card">
        <div
          className="resource-card-image"
          style={{backgroundImage: `url(${ObsKeyToURL(resource.image)})`}}
        >
          <div className="resource-card-mask">
            <EyeOutlined className="resource-card-mask-icon" onClick={previewFile} />
            <div className="resource-card-mask-icon-divider"></div>
            <DownloadOutlined
              className="resource-card-mask-icon"
              onClick={() => setFinishSign(false)}
            />
          </div>
          {!finishSign ? (
            <div className="download-progress">
              <DownloadFileModal
                name={resource.name}
                suffix={resource.suffix}
                url={resource.url}
                downloading={finishSign}
                setDownloading={setFinishSign}
              />
            </div>
          ) : (
            <></>
          )}
          <div className="file-tag">
            <CornerMarker suffix={resource.suffix} />
          </div>
        </div>
        <div className="resource-info-group">
          <div className="bold" style={{height: 44, overflow: 'hidden', color: '#40A9FF'}}>
            {resource.name}
          </div>
          <div className="resource-author-group">
            <div>
              <Avatar src={resource.author.image ? ObsKeyToURL(resource.author.image) : ''} />
              <span style={{color: '#8C8C8C'}}>
                {resource.author.nickname || resource.author.name}
              </span>
            </div>
            <span>{resource.updated_at.substring(0, resource.updated_at.indexOf('T'))}</span>
          </div>
        </div>
      </div>
      <Modal
        title="初识人工智能"
        visible={modalVisible}
        className="image-preview-content"
        footer={null}
        onCancel={handleCancel}
        wrapClassName="image-preview-wrap"
      >
        <div className="image-preview-body">
          <img src={ObsKeyToURL(resource.url)} alt="预览图片" className="preview-image" />
        </div>
      </Modal>
    </>
  )
}

export default ResourceCard
